(() => {
  const normalizePath = (path) => decodeURIComponent(path).replace(/\/+$/, '') || '/';
  const currentPath = normalizePath(window.location.pathname);
  const mobileNavigation = window.matchMedia('(max-width: 989px)');
  const syncBodyScrollLock = () => {
    const hasLargeOverlay = mobileNavigation.matches && Boolean(document.querySelector('.sports-nav__entry--mega.is-open'));
    document.body.classList.toggle('sports-nav-overlay-open', hasLargeOverlay);
  };

  document.querySelectorAll('.sports-nav__item').forEach((item) => {
    if (!item.href) return;
    const itemPath = normalizePath(new URL(item.href, window.location.origin).pathname);
    if (itemPath === currentPath) {
      item.classList.add('sports-nav__item--active');
      item.setAttribute('aria-current', 'page');
    }
  });

  document.querySelectorAll('.sports-nav__entry--mega').forEach((entry) => {
    let closeTimer;
    const cancelClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = undefined;
    };
    const categoryTriggers = Array.from(entry.querySelectorAll('[data-mega-category]'));
    const directLinks = Array.from(entry.querySelectorAll('.sports-nav__item--direct'));
    let activeTrigger = categoryTriggers[0] || null;
    const categoryPanels = Array.from(entry.querySelectorAll('[data-mega-category-panel]'));
    const megaHeading = entry.querySelector('[data-mega-heading]');
    const megaViewAll = entry.querySelector('[data-mega-view-all]');
    const megaViewLabel = entry.querySelector('[data-mega-view-label]');
    const teamsToggle = entry.querySelector('[data-mega-toggle]');
    const closeButton = entry.querySelector('[data-mega-close]');
    const collectionsPanel = entry.querySelector('[data-mega-panel="collections"]');
    const teamsPanel = entry.querySelector('[data-mega-panel="teams"]');
    const teamDrill = teamsPanel?.querySelector('[data-mobile-team-drill]');
    const teamDrillBack = teamDrill?.querySelector('[data-team-drill-back]');
    const teamDrillTitle = teamDrill?.querySelector('[data-team-drill-title]');
    const teamDrillOptions = teamDrill?.querySelector('[data-team-drill-options]');
    const teamSections = Array.from(teamsPanel?.querySelectorAll('[data-team-section]') || []);
    const featuredTeamOrder = ['fc-barcelona', 'real-madrid'];
    teamSections.forEach((section) => {
      const list = section.querySelector('ul');
      if (!list) return;
      [...section.querySelectorAll('[data-team-type]')]
        .sort((a, b) => {
          const aPriority = featuredTeamOrder.indexOf(a.dataset.teamName);
          const bPriority = featuredTeamOrder.indexOf(b.dataset.teamName);
          if (aPriority === -1 && bPriority === -1) return 0;
          if (aPriority === -1) return 1;
          if (bPriority === -1) return -1;
          return aPriority - bPriority;
        })
        .forEach((team) => list.appendChild(team));
    });
    const leagueChoices = Array.from(teamsPanel?.querySelectorAll('[data-team-league-choice]') || []);
    const selectionChoice = teamsPanel?.querySelector('[data-team-type-choice="seleccion"]');
    const otherLeagueChoice = teamsPanel?.querySelector('[data-team-other-url]');
    const teamViewAll = teamsPanel?.querySelector('[data-team-view-all]');
    const teamsHeading = teamsPanel?.querySelector('[data-teams-heading]');
    const emptyLeagueMessage = teamsPanel?.querySelector('[data-team-league-empty]');
    let teamDrillState = { level: 'type', type: null };
    const desktopInteraction = () => window.matchMedia('(min-width: 990px) and (hover: hover)').matches;

    const filterTeamList = (type, league = null) => {
      let visibleItems = 0;
      teamSections.forEach((section) => {
        const selected = section.dataset.teamSection === type;
        section.hidden = !selected;
        section.querySelectorAll('[data-team-type]').forEach((item) => {
          item.hidden = !selected || (league !== null && item.dataset.teamLeague !== league);
          if (!item.hidden) visibleItems += 1;
        });
      });
      if (emptyLeagueMessage) emptyLeagueMessage.hidden = visibleItems > 0;
    };

    const updateTeamViewAll = (choice) => {
      if (!teamViewAll || !choice) return;
      teamViewAll.href = choice.dataset.teamViewUrl;
      teamViewAll.firstChild.textContent = `${choice.dataset.teamViewLabel} `;
    };

    const setMobileTeamList = (type, league = null, label = null, choice = null) => {
      if (!teamsPanel || !teamDrillOptions || !teamDrillBack || !teamDrillTitle) return;
      teamsPanel.dataset.mobileLevel = 'teams';
      filterTeamList(type, league);
      teamDrillOptions.hidden = true;
      teamDrillBack.hidden = false;
      teamDrillTitle.textContent = label || (type === 'club' ? 'Clubes' : 'Selecciones');
      updateTeamViewAll(choice);
    };

    const selectDesktopChoice = (choice) => {
      if (!choice || window.innerWidth < 990) return;
      [...leagueChoices, selectionChoice].filter(Boolean).forEach((button) => {
        button.setAttribute('aria-pressed', String(button === choice));
      });
      if (choice.dataset.teamTypeChoice === 'seleccion') filterTeamList('seleccion');
      else filterTeamList('club', choice.dataset.teamLeagueChoice);
      updateTeamViewAll(choice);
    };

    const renderTeamDrill = (level = 'type') => {
      if (!teamDrill || !teamDrillOptions || !teamDrillBack || !teamDrillTitle || window.innerWidth >= 990) return;
      teamDrill.hidden = false;
      teamsPanel.dataset.mobileLevel = level;
      teamDrillOptions.hidden = false;
      teamDrillOptions.replaceChildren();
      if (emptyLeagueMessage) emptyLeagueMessage.hidden = true;
      teamSections.forEach((section) => {
        section.hidden = true;
        section.querySelectorAll('[data-team-type]').forEach((item) => { item.hidden = false; });
      });

      const addChoice = (label, action, icon = null) => {
        const button = document.createElement('button');
        button.type = 'button';
        if (icon) {
          button.classList.add('has-icon');
          button.appendChild(icon);
        }
        const labelSpan = document.createElement('span');
        labelSpan.textContent = label;
        const arrowSpan = document.createElement('span');
        arrowSpan.setAttribute('aria-hidden', 'true');
        arrowSpan.textContent = '→';
        button.append(labelSpan, arrowSpan);
        button.addEventListener('click', action);
        teamDrillOptions.appendChild(button);
      };

      if (level === 'type') {
        teamDrillState = { level: 'type', type: null };
        teamDrillBack.hidden = true;
        teamDrillTitle.textContent = '¿Qué quieres explorar?';
        if (teamSections.some((section) => section.dataset.teamSection === 'club' && section.querySelector('[data-team-type]'))) {
          addChoice('Clubes', () => renderTeamDrill('league'));
        }
        if (teamSections.some((section) => section.dataset.teamSection === 'seleccion' && section.querySelector('[data-team-type]'))) {
          addChoice('Selecciones', () => {
            teamDrillState = { level: 'teams', type: 'seleccion' };
            setMobileTeamList('seleccion', null, null, selectionChoice);
          });
        }
        return;
      }

      teamDrillState = { level: 'league', type: 'club' };
      teamDrillBack.hidden = true;
      teamDrillTitle.textContent = '';
      leagueChoices.forEach((choice) => {
        const label = choice.querySelector(':scope > span:nth-last-child(2)')?.textContent.trim() || choice.textContent.trim();
        const icon = choice.querySelector('.sports-nav__mega-icon')?.cloneNode(true) || null;
        addChoice(label, () => {
          teamDrillState = { level: 'teams', type: 'club', league: choice.dataset.teamLeagueChoice };
          setMobileTeamList('club', choice.dataset.teamLeagueChoice, label, choice);
        }, icon);
      });
      if (otherLeagueChoice) {
        const icon = otherLeagueChoice.querySelector('.sports-nav__mega-icon')?.cloneNode(true) || null;
        addChoice('Otras', () => window.location.assign(otherLeagueChoice.href), icon);
      }
    };

    const showMobileLeagues = () => {
      if (window.innerWidth >= 990) return;
      renderTeamDrill('league');
    };

    const resetDesktopTeams = () => {
      if (!teamsPanel || window.innerWidth < 990) return;
      delete teamsPanel.dataset.mobileLevel;
      if (teamDrill) teamDrill.hidden = true;
      selectDesktopChoice(leagueChoices[0] || selectionChoice);
    };

    const showTeams = (show) => {
      if (!teamsToggle || !collectionsPanel || !teamsPanel) return;
      teamsToggle.hidden = false;
      delete teamsPanel.dataset.directSelections;
      if (teamsHeading) teamsHeading.textContent = 'Explora por equipo';
      collectionsPanel.hidden = show;
      teamsPanel.hidden = !show;
      teamsToggle.setAttribute('aria-pressed', String(show));
      teamsToggle.querySelector('[data-teams-label]').hidden = show;
      teamsToggle.querySelector('[data-collections-label]').hidden = !show;
      if (window.innerWidth < 990) showMobileLeagues();
      else if (show) selectDesktopChoice(leagueChoices[0] || selectionChoice);
    };

    const showSelectionsDirect = () => {
      if (!collectionsPanel || !teamsPanel) return;
      collectionsPanel.hidden = true;
      teamsPanel.hidden = false;
      teamsPanel.dataset.directSelections = 'true';
      if (teamsToggle) {
        teamsToggle.hidden = true;
        teamsToggle.setAttribute('aria-pressed', 'false');
      }
      if (teamsHeading) teamsHeading.textContent = 'Selecciones';
      if (window.innerWidth < 990) {
        if (teamDrill) teamDrill.hidden = false;
        setMobileTeamList('seleccion', null, 'Selecciones', selectionChoice);
        if (teamDrillBack) teamDrillBack.hidden = true;
      } else {
        selectDesktopChoice(selectionChoice);
      }
    };

    const selectMegaCategory = (trigger, open = true) => {
      if (!trigger) return;
      activeTrigger = trigger;
      const category = trigger.dataset.megaCategory;
      categoryTriggers.forEach((button) => button.classList.toggle('is-selected', button === trigger));
      categoryPanels.forEach((panel) => { panel.hidden = panel.dataset.megaCategoryPanel !== category; });
      if (megaHeading) megaHeading.textContent = trigger.dataset.megaTitle || 'Explora fútbol';
      if (megaViewAll && trigger.dataset.megaUrl) megaViewAll.href = trigger.dataset.megaUrl;
      if (megaViewLabel) megaViewLabel.textContent = trigger.dataset.megaLinkLabel || 'Ver colección';
      if (category === 'national') {
        showSelectionsDirect();
      } else {
        showTeams(true);
      }
      if (open) setOpen(true);
    };

    const setOpen = (open) => {
      if (open) cancelClose();
      entry.classList.toggle('is-open', open);
      categoryTriggers.forEach((button) => button.setAttribute('aria-expanded', String(open && button === activeTrigger)));
      syncBodyScrollLock();
    };

    selectMegaCategory(activeTrigger, false);

    entry.addEventListener('mouseenter', cancelClose);
    entry.addEventListener('mouseleave', () => {
      if (!desktopInteraction()) return;
      cancelClose();
      closeTimer = window.setTimeout(() => {
        closeTimer = undefined;
        if (!entry.matches(':hover') && !entry.contains(document.activeElement)) setOpen(false);
      }, 240);
    });
    entry.addEventListener('focusout', (event) => {
      if (window.innerWidth >= 990 && !entry.contains(event.relatedTarget)) setOpen(false);
    });

    categoryTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        if (desktopInteraction()) selectMegaCategory(trigger);
      });
      trigger.addEventListener('focus', () => {
        if (window.innerWidth >= 990) selectMegaCategory(trigger);
      });
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const shouldClose = entry.classList.contains('is-open') && activeTrigger === trigger && window.innerWidth < 990;
        if (shouldClose) {
          setOpen(false);
          trigger.blur();
        } else {
          selectMegaCategory(trigger);
        }
      });
    });
    directLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        if (desktopInteraction()) setOpen(false);
      });
      link.addEventListener('focus', () => setOpen(false));
      link.addEventListener('click', () => setOpen(false));
    });

    teamsToggle?.addEventListener('click', () => {
      showTeams(teamsToggle.getAttribute('aria-pressed') !== 'true');
    });
    closeButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      setOpen(false);
      activeTrigger?.focus();
    });
    teamDrill?.addEventListener('click', (event) => event.stopPropagation());
    teamDrillBack?.addEventListener('click', () => {
      if (teamDrillState.type === 'club' && teamDrillState.level === 'teams') renderTeamDrill('league');
      else renderTeamDrill('league');
    });
    [...leagueChoices, selectionChoice].filter(Boolean).forEach((choice) => {
      choice.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.innerWidth >= 990 && choice.getAttribute('aria-pressed') === 'true') {
          window.location.assign(choice.dataset.teamViewUrl);
          return;
        }
        selectDesktopChoice(choice);
      });
    });

    const mobileTeamsMedia = window.matchMedia('(max-width: 989px)');
    mobileTeamsMedia.addEventListener('change', (event) => {
      if (activeTrigger?.dataset.megaCategory === 'national') showSelectionsDirect();
      else if (event.matches && teamsToggle?.getAttribute('aria-pressed') === 'true') showMobileLeagues();
      else resetDesktopTeams();
    });

    entry.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setOpen(false);
      activeTrigger?.focus();
    });
    document.addEventListener('click', (event) => {
      if (window.innerWidth < 990 && !event.composedPath().includes(entry)) setOpen(false);
    });
  });

  document.querySelectorAll('[data-mobile-more]').forEach((more) => {
    const trigger = more.querySelector('[data-mobile-more-trigger]');
    const panel = more.querySelector('[data-mobile-more-panel]');
    const navigation = more.closest('.sports-nav');
    if (!trigger || !panel || !navigation) return;

    const close = () => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = panel.hidden;
      navigation.querySelector('.sports-nav__entry--mega')?.classList.remove('is-open');
      navigation.querySelectorAll('[data-mega-category]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
      syncBodyScrollLock();
      panel.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', String(willOpen));
    });

    navigation.querySelectorAll('[data-mega-category]').forEach((item) => item.addEventListener('click', close));
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    document.addEventListener('click', (event) => {
      if (!event.composedPath().includes(more)) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || panel.hidden) return;
      close();
      trigger.focus();
    });
  });

  mobileNavigation.addEventListener('change', syncBodyScrollLock);
  window.addEventListener('pageshow', syncBodyScrollLock);
})();
